import React, { useState, useEffect } from "react";
import { API_URL, BASE_URL, Client_Id } from "../../../constants";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/base";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { setsignupState } from "../../../redux/signupSlice";
import { useDispatch } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
// import { useLinkedIn } from 'react-linkedin-login-oauth2';
import Form from "react-bootstrap/Form";
import { Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import {
  LoginSocialFacebook,
  LoginSocialLinkedin,
  LoginSocialApple,
} from "reactjs-social-login";
import { displayNotification } from "../../../helpers";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { jwtDecode } from 'jwt-decode'
// const REDIRECT_URI = "https://staging.commuterslink.com/auth/linkedin/callback";
const REDIRECT_URI = window.location.href;

const Signup = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [provider, setProvider] = useState("web");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullNameError, setFullNameError] = useState("");
  const [termsService, setTermsService] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
  const [isValidPassword, setIsValidPassword] = useState(true);
  const [passwordError, setPasswordError] = useState("");
  const [isValidConfirmPassword, setisValidConfirmPassword] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  function generateRandomPassword() {
    const length = 3;
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_-+=<>?";
    let password = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset.charAt(randomIndex);
    }

    return password;
  }

  function generateRandomOtp(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const googlesignup = useGoogleLogin({
    // clientId:
    //   "380385507444-lr0o69cgjb9l3jf35sm2h87ffuv650m6.apps.googleusercontent.com",
    clientId: Client_Id,
    onSuccess: (codeResponse) => handleSuccess(codeResponse),
    onError: (codeResponse) => handleFailure(codeResponse),
  });

  // const { linkedInLogin } = useLinkedIn({
  //   clientId: '86th1m5dtehgx3',
  //   redirectUri: `${window.location.origin}/linkedin`,
  //   onSuccess: (code) => {
  //     //console.log(code);
  //   },
  //   onError: (error) => {
  //     //console.log(error);
  //   },
  // });

  const handleFailure = (response) => {
    //console.log("handleFailure", response);
  };

  const handleSuccess = async (response) => {
    try {
      if (response && response.access_token) {
        const profile = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${response.access_token}`,
            },
            method: "get",
          }
        );

        if (profile.ok) {
          const userObject = await profile.json();
          const googleuserdata = {
            name: userObject.name,
            email: userObject.email,
            provider: "google",
            provider_id: "DasD" + generateRandomOtp(0, 1000000),
            googletoken: response.access_token,
            password: "jWaeo@123" + generateRandomPassword(),
            otp: generateRandomOtp(0, 1000000),
            phone: "",
          };

          await signupgoogledatapost(googleuserdata);
        } else {
          //console.error("Profile request failed with status:", profile.status);
        }
      }
    } catch (error) {
      //console.error("Error:", error.message);
    }
  };
  const openPopup = () => {
    Swal.fire({
      html: `
          <div>
            <div class="container mt-5 pt-1 text-center fw-bold fs-1 mb-4">
              <span>Privacy Policy</span>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-md-8 m-auto col-lg-12 col-sm-12 mb-5">
                  <div class="bg-light text-left">
                    <div class="p-4 text-justify">
                      <p>This Privacy Policy applies to the CommutersLink mobile application (referred to as the “Application”), developed by SysReforms International (referred to as the “Service Provider”). The Application is provided as a free service and is intended for use as is.</p>

                      <p>By using the Application, you agree to the collection, use, and disclosure of information in accordance with this policy.</p>

                      <h5>1: Location Data</h5>
                      <p>As a ride-sharing app, location data is essential for our core functionality. We may collect your device’s real-time location to:</p>
                      <ul>
                        <li>Match riders and drivers nearby</li>
                        <li>Provide accurate trip routing and real-time updates</li>
                        <li>Enhance user experience with personalized, location-based services</li>
                      </ul>
                      <p>We may also use aggregated, anonymized location data to:</p>
                      <ul>
                        <li>Analyze usage patterns and improve service efficiency</li>
                        <li>Monitor performance and detect unusual activity</li>
                        <li>Conduct service planning and expansion</li>
                      </ul>

                      <h5>2: Use of Information</h5>
                      <p>The information collected is used to:</p>
                      <ul>
                        <li>Provide and improve our ride-sharing services</li>
                        <li>Enable user-to-user communication (e.g., driver and passenger)</li>
                        <li>Send updates, service-related notifications, and promotional messages</li>
                        <li>Enhance security, detect fraud, and maintain a safe environment for all users</li>
                      </ul>

                      <h5>3: Third-Party Access and Services</h5>
                      <p>The Application may use third-party services that collect data independently. We encourage you to review their privacy policies for more information:</p>
                      <ul>
                        <li><a href="https://policies.google.com/privacy" target="_blank">Google Play Services</a></li>
                      </ul>
                      <p>We may share your data:</p>
                      <ul>
                        <li>With trusted service providers operating on our behalf, under strict confidentiality agreements</li>
                        <li>If required by law or in good faith to comply with legal obligations, protect users, investigate fraud, or respond to requests from authorities</li>
                      </ul>

                      <h5>4: Your Choices and Opt-Out Rights</h5>
                      <p>You can stop all collection of information by uninstalling the Application. You may use the standard uninstall option available on your device or through your app marketplace.</p>
                      <p>If you wish to opt out of promotional messages, you can do so via settings in the app or by contacting us directly.</p>

                      <h5>5: Data Retention Policy</h5>
                      <p>We retain user-provided information for as long as you use the Application and for a reasonable period thereafter. To request deletion of your personal data, contact us at <a href="http://commuterslink.com" target="_blank">commuterslink.com</a>, and we will respond within a reasonable timeframe.</p>

                      <h5>6: Children’s Privacy</h5>
                      <p>This Application is not intended for children under the age of 13. We do not knowingly collect personal information from children. If you believe that a child has provided us with personal data, please contact us immediately, and we will take the necessary steps to delete it.</p>

                      <h5>7: Security</h5>
                      <p>We take the protection of your data seriously and implement industry-standard measures, including:</p>
                      <ul>
                        <li>Encrypted communications</li>
                        <li>Secure storage practices</li>
                        <li>Access controls and authentication protocols</li>
                      </ul>
                      <p>Despite our efforts, no method of transmission or storage is 100% secure. We encourage you to use the Application responsibly and report any concerns.</p>

                      <h5>8: Changes to This Policy</h5>
                      <p>This Privacy Policy may be updated from time to time. Any changes will be posted on this page with the updated effective date. Your continued use of the Application constitutes acceptance of the updated policy.</p>

                      <h5>Contact Us</h5>
                      <p>For questions or concerns regarding this Privacy Policy or our data practices, please contact us via email at: <a href="mailto:support@commuterslink.com">support@commuterslink.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `,
      width: "50%", // Adjusted for better readability
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        popup: "text-start",
      },
    });
  };
  const handleFacebookSuccess = async (response) => {
    try {
      if (response && response.data.accessToken) {
        const facebookuserdata = {
          name: response.data.name,
          email: response.data.email,
          provider: response.provider,
          provider_id: "DasD" + generateRandomOtp(0, 1000000),
          facebooktoken: response.data.accessToken,
          password: "jWaeo@123" + generateRandomPassword(),
          otp: generateRandomOtp(0, 1000000),
          phone: "",
        };

        await signupfacebookdatapost(facebookuserdata);
      } else {
        //console.error("Profile request failed with status:", response);
      }
    } catch (error) {
      //console.error("Error:", error.message);
    }
  };
  const handleAppleSuccess = async (response) => {
    try {
      if (!response || !response.data || !response.data.authorization) {
        throw new Error("Invalid Apple Sign In response");
      }

      const { id_token, code } = response.data.authorization;
      const provider = response.provider; // 'apple'

      // Decode the id_token to get email and sub (user ID)
      let decodedToken;
      try {
        decodedToken = jwtDecode(id_token);
      } catch (error) {
        throw new Error("Failed to decode id_token: " + error.message);
      }
      const email = decodedToken.email || null;
      const userId = decodedToken.sub || null;

      let name = null;
      if (response.data.user) {
        // The user object may contain name (firstName, lastName)
        const { givenName, familyName } = response.data.user?.name || {};
        name =
          givenName && familyName
            ? `${givenName} ${familyName}`
            : givenName || familyName || null;
      }

      if (!name && email && typeof email === "string" && email.length >= 4) {
        name = email.substring(0, 4); 
      } else if (!name) {
        name = "Unknown"; 
      }

      const appleuserdata = {
        name: name,
        email: email,
        provider: provider || "apple",
        provider_id: userId || "DasD" + generateRandomOtp(0, 1000000),
        appleToken: id_token,
        password: "jWaeo@123" + generateRandomPassword(),
        authorization_code: code,
        otp: generateRandomOtp(0, 1000000),
        phone: "",
      };

      await signupappledatapost(appleuserdata);
    } catch (error) {
      //console.error("Error:", error.message);
    }
  };

  const signupappledatapost = async (userData) => {
    try {
      const body = {
        email: userData.email,
        number: userData.phone,
        provider: userData.provider,
        password: userData.password,
        provider_id: userData.provider_id,
        confirm_password: userData.password,
        name: userData.name,
        otp: userData.otp,
        token: userData.appleToken,
      };
      // //console.log("Signup Data Body:", body);
      const response = await fetch(`${API_URL}/api/v1/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const jsonresponse = await response.json();

      if (jsonresponse.statusCode === 200) {
        dispatch(
          setsignupState({
            email: body.email,
            provider: body.provider,
          })
        );
        // //console.log("Signup Data Response:", jsonresponse);
        navigate("/number-generate");
      } else {
        displayNotification("error", `${jsonresponse.message}`);
      }
    } catch (error) {
      //console.log("Signup Error:", error.message);
    }
  };

  const signupfacebookdatapost = async (userData) => {
    try {
      const body = {
        email: userData.email,
        number: userData.phone,
        provider: userData.provider,
        password: userData.password,
        provider_id: userData.provider_id,
        confirm_password: userData.password,
        name: userData.name,
        otp: userData.otp,
        token: userData.facebooktoken,
      };
      // //console.log("Signup Data Body:", body);
      const response = await fetch(`${API_URL}/api/v1/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const jsonresponse = await response.json();

      if (jsonresponse.statusCode === 200) {
        dispatch(
          setsignupState({
            email: body.email,
            provider: body.provider,
          })
        );
        // //console.log("Signup Data Response:", jsonresponse);
        navigate("/number-generate");
      } else {
        displayNotification("error", `${jsonresponse.message}`);
      }
    } catch (error) {
      //console.log("Signup Error:", error.message);
    }
  };

  const signupgoogledatapost = async (userData) => {
    try {
      const type = mode === "rider-registration" ? "rider" : "driver";
      const body = {
        email: userData.email,
        number: userData.phone,
        provider: userData.provider,
        password: userData.password,
        provider_id: userData.provider_id,
        confirm_password: userData.password,
        name: userData.name,
        type: type,
        otp: userData.otp,
        token: userData.googletoken,
      };
      // console.log("Signup Data Body:", body);
      const response = await fetch(`${API_URL}/api/v1/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const jsonresponse = await response.json();

      if (jsonresponse.statusCode === 200) {
        dispatch(
          setsignupState({
            email: body.email,
            provider: body.provider,
            type: body.type,
          })
        );
        // //console.log("Signup Data Response:", jsonresponse);
        navigate("/number-generate");
      } else {
        // alert("Error: " + jsonresponse.message);
        // Swal.fire({
        //   position: "top",
        //   icon: "",
        //   // text: `${jsonresponse.message}`,
        //   text: "Email Already Exists",
        //   customClass: {
        //     confirmButton: "swal-custom", // Apply custom CSS class to the OK button
        //   },
        // });
        // displayNotification("error", `${jsonresponse.message}`);
        displayNotification("error", `${jsonresponse.errors.email[0]}`);
      }
    } catch (error) {
      //console.log("Signup Error:", error.message);
    }
  };

  const postData = async () => {
    //navigate(`/otp?mode=${mode}`);

    try {
      setIsLoading(true);
      const phonePattern = /^03\d{9}$/;
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (
        fullName === "" ||
        email === "" ||
        phoneNumber === null ||
        password === "" ||
        confirmPassword === ""
      ) {
        displayNotification("error", "Please Fill All Fields");
        setIsLoading(false);
      } else if (password !== confirmPassword) {
        setIsLoading(false);
        displayNotification(
          "warning",
          "Confirm password is not matched with new password!"
        );
      } else if (!phonePattern.test(phoneNumber)) {
        setIsLoading(false);
        displayNotification(
          "warning",
          "Please follow the correct phone number format"
        );
      } else if (!emailPattern.test(email)) {
        setIsLoading(false);
        displayNotification(
          "warning",
          "Please follow the correct email format"
        );
      } else if (!isValidPassword) {
        displayNotification("error", "Please enter a valid password");
        setIsLoading(false);
      } else if (fullName.length < 3) {
        setIsLoading(false);
        displayNotification(
          "warning",
          "Full Name should have alteast 3 characters"
        );
      } else {
        if (termsService) {
          const body = {
            email: email,
            number: phoneNumber,
            signatur: "",
          };
          const response = await fetch(`${API_URL}/api/v1/send/otp`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          });

          const jsonresponse = await response.json();
          if (jsonresponse.statusCode === 200) {
            setIsLoading(false);
            dispatch(
              setsignupState({
                name: fullName,
                email: email,
                phone: phoneNumber,
                password: password,
                provider: provider,
                otp: jsonresponse.otp,
                token: jsonresponse.token,
                confirm_password: confirmPassword,
              })
            );
            // navigate("/otp");
            navigate(`/otp?mode=${mode}`);
          } else {
            const errors = jsonresponse.errors;
            for (const field of Object.keys(errors)) {
              setIsLoading(false);
              displayNotification("error", `${errors[field][0]}`);
            }
          }
        } else {
          setIsLoading(false);
          displayNotification("error", "Please Check Terms of Service");
        }
      }
    } catch (error) {
      //console.log(error.message);
    }
  };

  // const handleFullNameChange = (e) => {
  //   const value = e.target.value.replace(/[^a-z" "]/gi, "");
  //   setFullName(value);

  //   if (!/^[a-zA-Z" "]+$/.test(value) || value.length < 3) {
  //     setFullNameError(
  //       "Full Name must contain only alphabetic characters and be at least 3 characters long"
  //     );
  //   } else {
  //     setFullNameError("");
  //   }
  // };

  const handleFullNameChange = (e) => {
    const value = e.target.value.replace(/[^a-zA-Z" "]/gi, "");
    setFullName(value);

    if (value.replace(/ /g, "").length < 4) {
      // setFullNameError(
      //   "Full Name must contain at least 3 alphabetic characters (excluding spaces)"
      // );
      // displayNotification("error", "Full Name must contain at least 3 alphabetic characters (excluding spaces)Please Check Terms of Service");
    } else {
      setFullNameError("");
    }
  };
  const validateEmail = (email) => {
    // Regular expression pattern for validating email addresses
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email === "" || emailPattern.test(email)) {
      setEmail(email);
      setIsValidEmail(true);
    } else {
      setEmail(email);
      setIsValidEmail(false);
    }
  };

  const validatePhoneNumber = (phoneNumber) => {
    // Regular expression pattern for validating Pakistan phone numbers (must start with "03" and have 11 digits)
    const phonePattern = /^03\d{9}$/;
    if (phoneNumber === "" || phonePattern.test(phoneNumber)) {
      setPhoneNumber(phoneNumber);
      setIsValidPhoneNumber(true);
    } else {
      setPhoneNumber(phoneNumber);
      setIsValidPhoneNumber(false);
    }
  };
  const validatePassword = (password) => {
    // Regular expression pattern for validating passwords
    const passwordPattern =
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    setPassword(password);

    if (password === "") {
      setIsValidPassword(false);
      setPasswordError("Password is required");
    } else if (!passwordPattern.test(password)) {
      setIsValidPassword(false);
      setPasswordError(
        "Password must be at least 8 characters long, contain at least one letter, one number, and one special character (@$!%*?&#)"
      );
    } else {
      setIsValidPassword(true);
      setPasswordError("");
    }
  };

  const checkconfirmPassword = (cpassword) => {
    if (password === cpassword) {
      setConfirmPassword(cpassword);
      setisValidConfirmPassword(true);
    } else {
      setConfirmPassword(cpassword);
      setisValidConfirmPassword(false);
    }
  };

  return (
  <div >
      <div>
        <section
          id="sign-up"
          style={{
            backgroundColor: "#35677e",
            borderTopLeftRadius: "0",
            borderTopRightRadius: "0",
          }}
        >
<div
  className="container-fluid"
  style={{
    backgroundColor: "#35677e",
    paddingTop: "20px",
    paddingBottom: "20px",
  }}
>
            {/*             <div className="row d-flex">
              <div className="col-md-6  p-4 text-center text-dark fs-5 fw-bold" style={{ backgroundColor: 'white', borderTopLeftRadius: '0px' }}><i className="fa-solid fa-car text-dark"></i>Looking for a car</div>
              <div className="col-md-6  p-4 text-center text-warning fs-5 fw-bold" style={{ backgroundColor: '#3D3E3E', borderTopRightRadius: '0px' }}><i className="fa-regular fa-steering-wheel"></i>Offer Your car</div>
            </div> */}
           <div
  className="row justify-content-center"
  style={{ backgroundColor: "#35677e", margin: 0 }}
>
              {/* <div
                className="col-md-6 d-flex"
                style={{
                  marginTop: "12vh",
                }}
              >
                <Carousel
                  style={{
                    backgroundColor: "#eee",
                  }}
                  className="carousel-container"
                  prevIcon={null}
                  nextIcon={null}
                  indicators={null}
                >
                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup.png`}
                      alt="First slide"
                    />
                    <h4 className="text-success fw-bold text-center mt-2">
                      Share Actual Cost
                    </h4>
                  </Carousel.Item>

                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup-3.png`}
                      alt="First slide"
                    />
                    <h4 className="text-success fw-bold text-center mt-2">
                      Offer Your Car or Get a Seat in Other's Car
                    </h4>
                  </Carousel.Item>
                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup-4.png`}
                      alt="First slide"
                    />
                    <h4 className="text-success fw-bold text-center mt-2">
                      Share Ride for School University
                    </h4>
                  </Carousel.Item>
                  <Carousel.Item interval={4000}>
                    <img
                      className="d-block img-fluid w-auto"
                      src={`${BASE_URL}/assets/images/signup-6.png`}
                      alt="First slide"
                    />
                    <h4 className="text-success fw-bold text-center mt-2">
                      Share Ride For Office
                    </h4>
                  </Carousel.Item>
                </Carousel>
             
              </div> */}

              <div className="col-12 col-md-12 col-sm-6 mb-2 px-5">
                <h1
                  className="text-center text-custom"
                  style={{
                    color: "#FFC738",
                    marginBottom: "20px",
                    marginTop: "20px",
                  }}
                >
                  {" "}
                  Sign up
                </h1>{" "}
                {/* <p className="text-center fs-6 text-danger text-custom">
                  {" "}
                  <div
                    className="alert alert-info alert-dismissible fade show"
                    role="alert"
                  >
                    {" "}
                    <h6 className="text-left d-flex">
                      {" "}
                      <i className="fa-solid fa-triangle-exclamation fs-6  text-warning"></i>
                      <li style={{ listStyle: "none" }}>
                        {" "}
                        If you are offering your car, you may proceed with
                        registration, if you are 18 and older and you have a
                        driving license.
                      </li>
                    </h6>
                    <button
                      type=""
                      class="btn-close"
                      data-bs-dismiss="alert"
                      aria-label="Close"
                    ></button>
                  </div>
                
                </p> */}
                <Form className="text-center">
                  <Form.Group
                    className="mt-2 mb-1 text-center"
                    controlId="formfullName"
                  >
                    <Tooltip
                      title="Full Name must contain at least 3 alphabetic characters (excluding spaces)Please Check Terms of Service"
                      arrow
                    >
                      <TextField
                        fullWidth
                        className="custom-textfield"
                        variant="outlined"
                        label="Full Name"
                        type="text"
                        value={fullName}
                        onChange={handleFullNameChange}
                        // required
                        size="small"
                        error={!!fullNameError}
                        helperText={fullNameError}
                        sx={{ width: "100%",
                        }}              
                        />
                    </Tooltip>
                  </Form.Group>

                  <Form.Group
                    className="mt-2 text-center"
                    controlId="formBasicEmail"
                  >
                   
                  <TextField
  fullWidth
  variant="outlined"
  className="custom-textfield"
  type="email"
  label="Email"
  value={email}
  onChange={(e) => validateEmail(e.target.value)}
  size="small"
  error={!isValidEmail}
  helperText={!isValidEmail}
  sx={{ width:"100%"
}}
/>
                  </Form.Group>
                  <Form.Group
                    className="mt-2 text-center"
                    controlId="formBasicEmail"
                  >
                    <TextField
                      fullWidth
                      className="custom-textfield"
                      variant="outlined"
                      value={phoneNumber}
                      label="Mobile Number (03xxxxxxxxx)"
                      onChange={(e) => {
                        if (/^\d{0,11}$/.test(e.target.value)) {
                          validatePhoneNumber(e.target.value);
                        }
                      }}
                      // required
                      size="small"
                      error={!isValidPhoneNumber && phoneNumber !== ""}
                      helperText={
                        !isValidPhoneNumber && phoneNumber !== ""
                        //   &&
                        //  alert("Please Enter a valid phone number")
                      }
                      sx={{
                      width:"100%"
                      }}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mt-2 text-center"
                    controlId="formBasicEmail"
                  >
                    <Tooltip
                      title="Password must have 8 characters with alpha numeric & special character"
                      arrow
                    >
<TextField
  fullWidth
  variant="outlined"
  className="custom-textfield"
  type={showPassword ? "text" : "password"}
  label="Password"
  value={password}
  onChange={(e) => validatePassword(e.target.value)}
  size="small"
  error={!isValidPassword}
  helperText={!isValidPassword}
  sx={{ width:"100%"
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={togglePasswordVisibility}
          edge="end"
        >
          {showPassword ? (
            <VisibilityOffIcon sx={{ color: "#FFC738" }} />
          ) : (
            <VisibilityIcon sx={{ color: "#FFC738" }} />
          )}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>
                    </Tooltip>
                  </Form.Group>
                  <Form.Group
                    className="mt-2 text-center"
                    controlId="formBasicEmail"
                  >
                    <Tooltip title="Password must be same" arrow>
<TextField
  fullWidth
  className="custom-textfield"
  variant="outlined"
  type={showPassword1 ? "text" : "password"}
  label="Confirm Password"
  value={confirmPassword}
  onChange={(e) => checkconfirmPassword(e.target.value)}
  size="small"
  error={!isValidConfirmPassword}
  helperText={!isValidConfirmPassword}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={togglePasswordVisibility1}
          edge="end"
        >
          {showPassword1 ? (
            <VisibilityOffIcon sx={{ color: "#FFC738" }} />
          ) : (
            <VisibilityIcon sx={{ color: "#FFC738" }} />
          )}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>
                    </Tooltip>
                  </Form.Group>
                  <Form.Group
                    className="mt-2 text-center"
                    controlId="formBasicEmail"
                  >
                    <FormControlLabel
                      control={
<Checkbox
  className="custom-checkbox"
  value="termsService"
  checked={termsService}
  onChange={(e) => setTermsService(e.target.checked)}
  size="small"
/>
                      }
                      isLoading
                      label={
                        <div id="span-text" className="mr-5  text-bold">
                          I agree with all statements in
                          {/* <Link
                            // to={"/terms_services"}
                            style={{ textDecoration: "none" }}
                          > */}
                          <span
                            style={{
                              color: "#FFC738",
                              textDecoration: "none",
                            }}
                            onClick={openPopup}
                          >
                            &nbsp; Terms of service
                          </span>
                          {/* </Link> */}
                        </div>
                      }
                    />
                  </Form.Group>
                  <div className="col-md-12   text-center">
                    <Button
                      className="btn-custom1 mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold"
                      onClick={() => postData()}
                    >
                      {isLoading === true ? (
                        <span>
                          <i className="fa fa-spinner fa-spin" /> Submitting....
                        </span>
                      ) : (
                        "Sign up"
                      )}
                    </Button>
                    {/* <Button
                      className="btn-custom mx-2 px-4 py-2 rounded rounded-5 text-custom fw-bold"
                      onClick={() => postData()}
                    >
                      Sign up
                    </Button> */}
                  </div>
                  <div className="container text-center">
                    <div className="row d-flex">
                      <div className="column mr-3">
                        <p className=" text-white" id="text2">
                          Or continue with
                        </p>
                      </div>
                      <div className="column">
                        <ul
                          className="list-unstyled  d-flex "
                          style={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <li className="mr-3">
                            <Tooltip title="Signup With Google">
                              <a onClick={googlesignup}>
                                <img
                                  src={`${BASE_URL}/assets/images/google.png`}
                                  alt=""
                                  style={{
                                    height: "25px",
                                    width: "25px",
                                    cursor: "pointer",
                                  }}
                                />
                              </a>
                            </Tooltip>
                          </li>
                          <li className="mr-1">
                            <LoginSocialFacebook
                              // appId="264760359845922"
                              appId="832351251716749"
                              onResolve={(response) => {
                                handleFacebookSuccess(response);
                              }}
                              onReject={(error) => {
                                //console.log("Error Message:", error);
                              }}
                            >
                              <Tooltip title="Signup With Facebook">
                                <img
                                  src={`${BASE_URL}/assets/images/facebook.png`}
                                  alt=""
                                  style={{
                                    height: "27px",
                                    width: "27px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </LoginSocialFacebook>
                          </li>
                          <li className="mr-1">
                            <LoginSocialApple
                              client_id="com.commuterslink.applelogin"
                              redirect_uri="https://acc2646da6af.ngrok-free.app/"
                              onResolve={(response) => {
                                console.log("Apple login success:", response);

                                handleAppleSuccess(response);
                              }}
                              onReject={(error) => {
                                console.error("Apple login error:", error);
                              }}
                            >
                              <Tooltip title="Signup With Apple">
                                <img
                                  src={`${BASE_URL}/assets/images/apple.png`}
                                  alt="Apple login"
                                  style={{
                                    height: "45px",
                                    width: "43px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Tooltip>
                            </LoginSocialApple>
                          </li>

                          {/* <li>
                            <LoginSocialLinkedin
                              client_id="86th1m5dtehgx3"
                              client_secret="YY1HZ3JYb4jM5btI"
                              redirect_uri={REDIRECT_URI}
                              onResolve={(response) => {
                                //console.log("LinkedIn Response:", response);
                              }}
                              onReject={(error) => {
                                //console.log("LinkedIn Error Message:", error);
                              }}
                            >
                              <Tooltip title="Signup With Linkedin">
                                <a>
                                  <img
                                    src={`${BASE_URL}/assets/images/linkedin.png`}
                                    alt=""
                                    style={{
                                      height: "35px",
                                      width: "35px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </a>
                              </Tooltip>
                            </LoginSocialLinkedin>
                          </li> */}
                        </ul>
                      </div>
                    </div>
                    <hr id="hrline2" style={{color:"#fff"}} />
                    <div className="text-center mb-1 text-white">
                      Already have account on CommuterLinks? &nbsp;
                      <Link to={"/login"} style={{ textDecoration: "none" }}>
                        <span
                          style={{ color: "#FFC738", textDecoration: "none" }}
                        >
                          Login
                        </span>
                      </Link>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Signup;
